<template>
	<div>
		<div
			style="
				border: 1px solid;
				border-color: #f9a168;
				margin-bottom: 10px;
				border-radius: 2px;
			"
		>
			<el-card shadow="never">
				<div
					style="
						display: flex;
						justify-content: space-between;
						align-items: center;
						width: 100%;
					"
				>
					<div style="display: flex; align-items: center; width: 100%">
						<div style="width: 88%">
							<input
								v-if="
									question.form_question_info.input_type_info.name ==
									'Checklist'
								"
								:disabled="checkDisabled(question)"
								type="checkbox"
								style="width: 15px; height: 15px; margin-right: 10px"
								v-model="question.checked"
							/>
							<b>{{ sr_no + 1 }} .</b>
							<span style="margin-left: 5px">{{
								question.form_question_info.name
							}}</span
							><span
								style="margin-left: 5px; color: #ff4d4d"
								v-if="question.form_question_info.is_mandatory"
								>*</span
							>
							<span
								v-if="question.form_question_info.is_critical"
								style="
									color: #ff4d4d;
									font-weight: bolder;
									font-size: 12px;
									margin-left: 10px;
								"
								>(critical)</span
							>
							<span
								v-if="
									[
										'Checklist',
										'Select any one',
										'Multiselect',
										'Timer',
									].includes(question.form_question_info.input_type_info.name)
								"
							>
								<span
									v-if="!question.marked_as_na"
									@click="
										company_details.access_level == 'admin'
											? clear_selection(question, sr_no)
											: ''
									"
									style="
										text-align: center;
										color: #d26300;
										border: none;
										cursor: pointer;
										display: inline-block;
									"
								>
									<span style="padding: 0px 10px 0px 10px; font-size: 10px"
										>Clear</span
									>
								</span>
							</span>
							<span
								v-if="
									question.form_question_info.description &&
									question.form_question_info.description != ''
								"
								style="margin-left: 10px"
							>
								<el-popover placement="right-start" width="450" trigger="hover">
									<div
										slot="reference"
										style="display: inline-block; line-height: 1"
									>
										<i style="color: #d26300" class="el-icon-info"></i>
									</div>
									<div style="font-size: 13px; word-break: break-word">
										<div v-html="question.form_question_info.description"></div>
									</div>
								</el-popover>
							</span>
						</div>
						<div
							v-if="
								question.form_question_info.input_type_info.name == 'Yes / No'
							"
							style="width: 12%; align-items: flex-end"
						>
							<div
								v-if="Question_form_Details.scoring_type != 'all_pass'"
								style="font-size: 13px"
							>
								Points -
								{{
									question.current_question_points != null ||
									question.current_question_points != undefined
										? question.current_question_points
										: 0
								}}
								of
								{{ question.total_points }}
							</div>
						</div>
					</div>
				</div>
				<div
					style="margin-top: 10px"
					v-if="
						question.form_question_info.form_question_attachments_list.length !=
						0
					"
				>
					<div
						@click="
							get_image(
								question.form_question_info.form_question_attachments_list
							)
						"
						style="
							color: #f9a168;
							font-size: 13px;
							margin-left: 23px;
							cursor: pointer;
						"
					>
						<b><u>View Media</u></b>
						<img
							style="margin-left: 5px"
							width="15px"
							src="../../../../assets/icons/Attach.png"
						/>
					</div>
				</div>
				<div style="margin-left: 23px; margin-top: 15px">
					<div
						v-if="
							question.form_question_info.input_type_info.name == 'Yes / No' &&
							!checkDisabled(question)
						"
						style="display: flex; justify-content: space-between; width: 23%"
					>
						<div
							@click="button_condition_yes(question, sr_no)"
							style="
								width: 30%;
								height: 40px;
								text-align: center;
								border-radius: 12px;
								border-color: #d26300;
								color: #d26300;
								border: 1px solid;
								cursor: pointer;
							"
							:style="question.green_color"
						>
							<div style="padding-top: 10px">Yes</div>
						</div>
						<div
							@click="button_condition_no(question, sr_no)"
							style="
								width: 30%;
								height: 40px;
								text-align: center;
								border-radius: 12px;
								border-color: #d26300;
								color: #d26300;
								border: 1px solid;
								cursor: pointer;
							"
							:style="question.red_color"
						>
							<div style="padding-top: 10px">No</div>
						</div>
						<div
							@click="
								company_details.access_level == 'admin'
									? clear_selection(question, sr_no)
									: ''
							"
							style="
								width: 33%;
								height: 40px;
								text-align: center;
								color: #d26300;
								border: none;
								cursor: pointer;
							"
						>
							<div style="padding-top: 10px">Clear</div>
						</div>
					</div>
					<div
						v-if="
							question.form_question_info.input_type_info.name == 'Yes / No' &&
							checkDisabled(question)
						"
						style="display: flex; justify-content: space-between; width: 15%"
					>
						<el-button
							disabled
							style="
								width: 45%;
								height: 40px;
								text-align: center;
								border-radius: 12px;
								border-color: #d26300;
								color: #d26300;
								border: 1px solid;
								cursor: pointer;
								background-color: #d3d3d3;
								padding: 0px 0px 0px 0px;
							"
						>
							Yes
						</el-button>
						<el-button
							disabled
							style="
								width: 45%;
								height: 40px;
								text-align: center;
								border-radius: 12px;
								border-color: #d26300;
								color: #d26300;
								border: 1px solid;
								cursor: pointer;
								background-color: #d3d3d3;
								padding: 0px 0px 0px 0px;
							"
						>
							No
						</el-button>
					</div>
					<div
						v-if="
							question.form_question_info.input_type_info.name == 'Long Text' ||
							question.form_question_info.input_type_info.name == 'Long text'
						"
						style="display: flex"
					>
						<el-input
							:disabled="checkDisabled(question)"
							type="textarea"
							:rows="4"
							placeholder="Enter long description"
							v-model="question.text_input"
							class="input-class"
							:minlength="0"
							:maxlength="350"
							show-word-limit
							style="width: 80%"
						>
						</el-input>
						<div
							@click="
								company_details.access_level == 'admin'
									? clear_selection(question, sr_no)
									: ''
							"
							style="
								width: 65px;
								height: 40px;
								text-align: center;
								color: #d26300;
								border: none;
								cursor: pointer;
							"
						>
							<div style="padding-top: 30px">Clear</div>
						</div>
					</div>
					<div
						v-if="
							question.form_question_info.input_type_info.name == 'Short text'
						"
						style="display: flex"
					>
						<el-input
							:disabled="checkDisabled(question)"
							type="text"
							v-model="question.text_input"
							placeholder="Enter short description"
							class="input-class"
						/>
						<div
							@click="
								company_details.access_level == 'admin'
									? clear_selection(question, sr_no)
									: ''
							"
							style="
								width: 65px;
								height: 40px;
								text-align: center;
								color: #d26300;
								border: none;
								cursor: pointer;
							"
						>
							<div style="padding-top: 10px">Clear</div>
						</div>
					</div>
					<div
						v-if="
							question.form_question_info.input_type_info.name == 'Number input'
						"
						style="display: flex"
					>
						<el-input
							:disabled="checkDisabled(question)"
							type="number"
							v-model="question.number_input"
							placeholder="Enter number"
							class="input-class"
							style="width: 30%"
						/>
						<div
							@click="
								company_details.access_level == 'admin'
									? clear_selection(question, sr_no)
									: ''
							"
							style="
								width: 65px;
								height: 40px;
								text-align: center;
								color: #d26300;
								border: none;
								cursor: pointer;
							"
						>
							<div style="padding-top: 10px">Clear</div>
						</div>
					</div>
					<div
						v-if="
							question.form_question_info.input_type_info.name ==
								'Temperature' ||
							question.form_question_info.input_type_info.name == 'TPM'
						"
						style="display: flex"
					>
						<span style="width: 10%; margin-top: 10px">Test Value</span>
						<el-input
							:disabled="checkDisabled(question)"
							@input="get_temperature_content(question, question.number_input)"
							type="number"
							v-model.number="question.number_input"
							:placeholder="
								question.form_question_info.input_type_info.name ==
								'Temperature'
									? 'Enter Temperature'
									: 'Enter TPM'
							"
							:style="question.test_color"
							:class="
								question.test_color == '#FF0000'
									? 'input-class-red'
									: 'input-class'
							"
							style="background: white; width: 20%"
						/>
						<span
							v-if="question.show_temp_retest"
							style="width: 10%; margin-top: 10px; margin-left: 5%"
							>Retest Value</span
						>
						<el-input
							v-if="question.show_temp_retest"
							:disabled="checkDisabled(question)"
							@input="
								get_temperature_content_retest(
									question,
									question.repeat_number_input
								)
							"
							type="text"
							v-model="question.repeat_number_input"
							:placeholder="
								question.form_question_info.input_type_info.name ==
								'Temperature'
									? 'Enter Temperature'
									: 'Enter TPM'
							"
							:style="question.test_color_retest"
							:class="
								question.test_color_retest == '#FF0000'
									? 'input-class-red'
									: 'input-class'
							"
							style="background: white; width: 20%"
						/>
						<div
							@click="
								company_details.access_level == 'admin'
									? clear_selection(question, sr_no)
									: ''
							"
							style="
								width: 65px;
								height: 40px;
								text-align: center;
								color: #d26300;
								border: none;
								cursor: pointer;
							"
						>
							<div style="padding-top: 10px">Clear</div>
						</div>
					</div>
					<div
						v-if="
							question.form_question_info.input_type_info.name ==
							'Select any one'
						"
						style="
							display: grid;
							grid-template-columns: 100%;
							align-items: center;
						"
					>
						<div
							v-for="(obj, key) in question.form_question_info
								.input_options_list"
							:key="key"
							class="mb-3"
							style="display: flex; align-items: flex-start; width: 100%"
						>
							<el-radio
								:disabled="checkDisabled(question)"
								v-model="question.input_option"
								:label="obj.id"
								style="margin-top: 2px; margin-right: -5px"
								>{{ "" }}</el-radio
							>
							<div
								style="
									width: 60%;
									word-wrap: break-word;
									white-space: normal;
									display: flex;
									flex-direction: column;
								"
							>
								<div
									v-for="(chunk, chunkIndex) in splitText(obj.name)"
									:key="chunkIndex"
									style="
										display: flex;
										flex-direction: row;
										align-items: center;
									"
								>
									<span>{{ chunk }}</span>
								</div>
							</div>
							<div
								v-if="Question_form_Details.scoring_type != 'not_applicable'"
								style="font-size: 12px; margin-top: 2px"
							>
								<b>Points - {{ obj.value }}</b>
							</div>
						</div>
					</div>
					<div
						v-if="
							question.form_question_info.input_type_info.name == 'Multiselect'
						"
						style="
							display: grid;
							grid-template-columns: 100%;
							align-items: center;
						"
					>
						<div
							v-for="(obj, key) in question.form_question_info
								.input_options_list"
							:key="key"
							class="mb-3"
							style="display: flex; align-items: flex-start; width: 100%"
						>
							<input
								:disabled="checkDisabled(question)"
								type="checkbox"
								v-model="obj.selected"
								style="margin-top: 2px; margin-right: 10px"
							/>
							<div
								style="
									width: 60%;
									word-wrap: break-word;
									white-space: normal;
									display: flex;
									flex-direction: column;
								"
							>
								<div
									v-for="(chunk, chunkIndex) in splitText(obj.name)"
									:key="chunkIndex"
									style="
										display: flex;
										flex-direction: row;
										align-items: center;
									"
								>
									<span>{{ chunk }}</span>
								</div>
							</div>
							<div
								v-if="Question_form_Details.scoring_type != 'not_applicable'"
								style="font-size: 12px; margin-top: 2px"
							>
								<b>Points - {{ obj.value }}</b>
							</div>
						</div>
					</div>
					<div
						v-if="question.form_question_info.input_type_info.name == 'Date'"
						style="display: flex"
					>
						<el-date-picker
							style="width: 30%"
							v-model="question.date_input"
							type="date"
							placeholder="Select Date"
							class="date"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							:disabled="checkDisabled(question)"
						>
						</el-date-picker>
						<div
							@click="
								company_details.access_level == 'admin'
									? clear_selection(question, sr_no)
									: ''
							"
							style="
								width: 65px;
								height: 40px;
								text-align: center;
								color: #d26300;
								border: none;
								cursor: pointer;
							"
						>
							<div style="padding-top: 10px">Clear</div>
						</div>
					</div>
					<div
						v-if="question.form_question_info.input_type_info.name == 'Time'"
						style="display: flex"
					>
						<el-time-select
							v-model="question.time_input"
							:picker-options="{
								start: '00:00',
								step: '00:15',
								end: '23:45',
							}"
							placeholder="Select time"
							class="date"
							:disabled="checkDisabled(question)"
						>
						</el-time-select>
						<div
							@click="
								company_details.access_level == 'admin'
									? clear_selection(question, sr_no)
									: ''
							"
							style="
								width: 65px;
								height: 40px;
								text-align: center;
								color: #d26300;
								border: none;
								cursor: pointer;
							"
						>
							<div style="padding-top: 10px">Clear</div>
						</div>
					</div>
					<div
						v-if="
							question.form_question_info.input_type_info.name == 'Datetime'
						"
						style="display: flex"
					>
						<el-date-picker
							style="width: 30%"
							v-model="question.datetime_input"
							type="datetime"
							placeholder="Select Date & Time"
							class="date"
							format="yyyy-MM-dd HH:mm"
							value-format="yyyy-MM-dd HH:mm"
							:disabled="checkDisabled(question)"
						>
						</el-date-picker>
						<div
							@click="
								company_details.access_level == 'admin'
									? clear_selection(question, sr_no)
									: ''
							"
							style="
								width: 65px;
								height: 40px;
								text-align: center;
								color: #d26300;
								border: none;
								cursor: pointer;
							"
						>
							<div style="padding-top: 10px">Clear</div>
						</div>
					</div>
					<div>
						<div
							v-if="
								question.form_question_info.input_type_info.name === 'Timer'
							"
							style="display: grid"
						>
							<div
								v-for="(attempt, attemptIndex) in question.form_question_info
									.timer_attempts"
								:key="attemptIndex"
								class="stopwatch-container"
							>
								<div class="time-index">Time {{ attemptIndex + 1 }}</div>
								<span
									v-if="
										question.form_question_info.stopwatches &&
										question.form_question_info.stopwatches[attemptIndex]
									"
									class="stopwatch"
								>
									{{
										formatTime(
											question.form_question_info.stopwatches[attemptIndex].time
										).formattedTime
									}}
								</span>
								<el-button
									class="button-class-white2"
									size="mini"
									style="border: none; margin: 0px; height: 30px"
									:disabled="
										shouldDisableStart(
											sr_no,
											attemptIndex,
											question.form_question_info
										) || checkDisabled(question)
									"
									@click="
										startStopwatch(
											sr_no,
											attemptIndex,
											question.form_question_info
										)
									"
									v-if="
										question.form_question_info &&
										question.form_question_info.showStartButton &&
										question.form_question_info.showStartButton[attemptIndex]
									"
								>
									Start
								</el-button>
								<el-button
									class="button-class-white2"
									size="mini"
									style="border: none; margin: 0px; height: 30px"
									@click="
										stopStopwatch(
											sr_no,
											attemptIndex,
											question.form_question_info
										)
									"
									:disabled="checkDisabled(question)"
									v-if="
										question.form_question_info &&
										question.form_question_info.showStopButton &&
										question.form_question_info.showStopButton[attemptIndex]
									"
								>
									Stop
								</el-button>
								<el-button
									class="button-class-white2"
									size="mini"
									style="border: none; margin: 0px; height: 30px"
									@click="
										resetStopwatch(
											sr_no,
											attemptIndex,
											question.form_question_info
										)
									"
									:disabled="checkDisabled(question)"
									v-if="
										question.form_question_info &&
										question.form_question_info.showResetButton &&
										question.form_question_info.showResetButton[attemptIndex]
									"
								>
									Reset
								</el-button>
							</div>
							<!-- Display total and average time -->
							<div class="stopwatch-container">
								<div class="time-index">Total Time:</div>
								<div class="stopwatch" style="margin-left: 72px">
									<strong>{{ totalTime(question.form_question_info) }}</strong>
								</div>
							</div>
							<div class="stopwatch-container">
								<div class="time-index">Average Time:</div>
								<div class="stopwatch" style="margin-left: 52px">
									<strong>{{
										averageTime(question.form_question_info)
									}}</strong>
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="
							question.form_question_info.input_type_info.name == 'Signature' &&
							!checkDisabled(question)
						"
					>
						<div
							v-if="question.form_question_execution_attachments.length == 0"
							id="app"
							style="border: 1px solid; width: 510px"
						>
							<canvas
								width="500"
								height="140"
								:ref="`question.signatureCanvas${sr_no}`"
							></canvas>
						</div>
						<img
							v-else
							:src="question.form_question_execution_attachments[0].src"
							style="border: 1px solid"
						/>
						<el-button
							:disabled="checkDisabled(question)"
							@click="clearSignature(sr_no, question)"
							class="button-class-white2"
							style="border: none; width: 20%; margin-left: 35%"
						>
							Clear Signature
						</el-button>
					</div>
					<div
						v-if="
							question.form_question_info.input_type_info.name == 'Signature' &&
							checkDisabled(question)
						"
					>
						<div
							v-if="question.form_question_execution_attachments.length == 0"
							style="border: 1px solid #c0c4cc; width: 510px"
						>
							<canvas width="500" height="140" color="#c0c4cc"></canvas>
						</div>
					</div>
					<div
						v-if="question.form_question_info.input_type_info.name == 'Rating'"
						style="display: flex"
					>
						<el-select
							class="select"
							v-model="question.number_input"
							:disabled="checkDisabled(question)"
							@change="update_rating"
							style="width: 20%"
						>
							<el-option
								v-for="(item_r, key_r) in question.rating_list"
								:key="key_r"
								:label="item_r.label"
								:value="item_r.value"
							>
							</el-option>
						</el-select>
						<el-slider
							style="color: red; width: 60%; margin-left: 30px"
							@change="update_rating"
							:disabled="checkDisabled(question)"
							v-model="question.number_input"
							:min="question.form_question_info.minimum_value"
							:max="10"
							show-stops
						>
						</el-slider>
						<div
							@click="
								company_details.access_level == 'admin'
									? clear_selection(question, sr_no)
									: ''
							"
							style="
							width: 65px;
							height: 40px;
							text-align: center;
							color: #d26300;
							border: none;
							cursor: pointer;
                            margin
						"
						>
							<div style="padding-top: 10px">Clear</div>
						</div>
					</div>
					<div
						v-if="
							question.form_question_info.input_type_info.name == 'Dropdown'
						"
						style="display: flex"
					>
						<el-select
							style="width: 30%"
							class="select"
							v-model="question.input_option"
							@change="update_rating"
							filterable
							:clearable="true"
							:disabled="checkDisabled(question)"
						>
							<el-option
								v-for="(item_r, key_r) in question.form_question_info
									.input_options_list"
								:key="key_r"
								:label="splitOptionText(item_r.name)"
								:value="item_r.id"
							>
							</el-option>
						</el-select>

						<div
							@click="
								company_details.access_level == 'admin'
									? clear_selection(question, sr_no)
									: ''
							"
							style="
								width: 65px;
								height: 40px;
								text-align: center;
								color: #d26300;
								border: none;
								cursor: pointer;
							"
						>
							<div style="padding-top: 10px">Clear</div>
						</div>
					</div>
					<div
						v-if="
							question.form_question_info.input_type_info.name ==
							'Mobile number'
						"
						style="display: flex; width: 100%"
					>
						<el-select
							style="margin-top: 2px; width: 20%"
							class="select"
							v-model="question.country_number_input"
							@change="update_rating"
							filterable
							:clearable="true"
							:disabled="checkDisabled(question)"
						>
							<el-option
								v-for="(item_r, key_r) in countryList"
								:key="key_r"
								:label="`${item_r.phonecode} (${item_r.name})`"
								:value="item_r.phonecode"
							>
							</el-option>
						</el-select>
						<el-input
							:disabled="checkDisabled(question)"
							type="text"
							v-model.number="question.text_input"
							placeholder="Enter mobile number"
							class="input-class"
							style="width: 30%; margin-left: 10px; height: 35px"
							@input="validateInput(question)"
						/>
						<div
							@click="
								company_details.access_level == 'admin'
									? clear_selection(question, sr_no)
									: ''
							"
							style="
								width: 65px;
								height: 40px;
								text-align: center;
								color: #d26300;
								border: none;
								cursor: pointer;
							"
						>
							<div style="padding-top: 10px">Clear</div>
						</div>
					</div>
					<div
						v-if="question.form_question_info.input_type_info.name == 'Email'"
						style="display: flex"
					>
						<el-input
							:disabled="checkDisabled(question)"
							type="email"
							v-model.number="question.text_input"
							placeholder="Enter Email"
							class="input-class"
							style="width: 30%"
						/>
						<div
							@click="
								company_details.access_level == 'admin'
									? clear_selection(question, sr_no)
									: ''
							"
							style="
								width: 65px;
								height: 40px;
								text-align: center;
								color: #d26300;
								border: none;
								cursor: pointer;
							"
						>
							<div style="padding-top: 10px">Clear</div>
						</div>
					</div>
				</div>
				<div style="margin-top: 20px; display: flex; justify-content: flex-end">
					<img
						v-if="
							question.form_question_info.input_type_info.name != 'Signature'
						"
						@click="image_upload(question.id)"
						width="25px"
						src="../../../../assets/icons/Camera.png"
						style="margin-left: 0px; cursor: pointer"
					/>
					<span
						v-if="
							question.form_question_info.input_type_info.name != 'Signature'
						"
						@click="image_upload(question.id)"
						style="margin-left: 5px; margin-top: 3px; cursor: pointer"
						>Image
						<span
							style="color: red"
							v-if="question.form_question_info.is_image_required"
							>*</span
						>
					</span>
					<input
						v-if="
							question.form_question_info.input_type_info.name != 'Signature'
						"
						multiple
						:maxlength="5"
						type="file"
						@change.prevent="upload_file_handler($event, question)"
						:id="'fileUploadSelector' + question.id"
						style="display: none"
						accept="image/*"
					/>
					<img
						v-if="
							question.form_question_info.input_type_info.name != 'Signature'
						"
						@click="show_comment(question)"
						width="25px"
						src="../../../../assets/icons/Comment1.png"
						style="margin-left: 30px; cursor: pointer"
					/>
					<span
						v-if="
							question.form_question_info.input_type_info.name != 'Signature'
						"
						@click="show_comment(question)"
						style="margin-left: 5px; margin-top: 3px; cursor: pointer"
						>Comment
						<span
							style="color: red"
							v-if="question.form_question_info.is_comment_required"
							>*</span
						></span
					>
					<img
						v-if="
							project_info_object.execution_setup_info.manual_actions_applicable
						"
						style="cursor: pointer; margin-left: 30px"
						@click="raise_ticket(question)"
						width="25px"
						src="../../../../assets/icons/ComputerSupport1.png"
					/>
					<span
						v-if="
							project_info_object.execution_setup_info.manual_actions_applicable
						"
						style="cursor: pointer; margin-left: 5px; margin-top: 3px"
						@click="raise_ticket(question)"
					>
						Raise Action
					</span>
					<span
						v-if="question.form_question_info.is_not_applicable"
						style="margin-top: 3px; margin-left: 30px"
						>NA</span
					>
					<el-switch
						v-if="question.form_question_info.is_not_applicable"
						@change="get_marked_as_na_values(question, question.marked_as_na)"
						v-model="question.marked_as_na"
						active-color="#41BE62"
						style="margin-left: 5px"
					>
					</el-switch>
				</div>
				<div v-if="question.show_comment" style="margin-top: 10px">
					<el-input
						type="textarea"
						:rows="2"
						placeholder="Enter Comment"
						v-model="question.comment"
						class="input-class"
						:minlength="0"
						:maxlength="350"
					/>
					<div class="comment-container">
						<div @click="hide_comment(question)" class="hide-comment-btn">
							<div class="hide-comment-text">Hide Comment</div>
						</div>
					</div>
				</div>
				<div
					v-if="question.form_question_info.input_type_info.name != 'Signature'"
				>
					<el-row style="margin-top: 10px">
						<el-col
							style="margin-right: 20px"
							v-for="(itemz, idxz) in question.fileURLArray"
							:key="idxz"
							:span="4"
							:offset="1"
						>
							<div
								v-if="/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(itemz.file_name)"
								style="cursor: pointer"
							>
								<el-tooltip
									class="item"
									effect="light"
									content="Click to show image"
									placement="bottom"
								>
									<div class="image-container">
										<img
											@click="show_excel(itemz.src)"
											class="uploaded-image"
											:src="itemz.src"
											alt="Image Preview"
											id="preview-img"
										/>
									</div>
								</el-tooltip>
								<el-tooltip
									class="item"
									effect="light"
									content="Click to show Video Preview"
									placement="bottom"
									v-if="
										/\.(mp4|mov|wmv|avi|avchd|flv|f4v|swf|mkv|webm|mpg|mp2|mpeg|mpe|mpv|video)$/i.test(
											itemz.file_name
										)
									"
								>
									<video
										@click="show_excel(itemz.src)"
										:src="itemz.src"
										controls
										id="preview-video"
										style="width: 100%; height: 500px; object-fit: cover"
									></video>
								</el-tooltip>
								<el-tooltip
									class="item"
									effect="light"
									content="Click to show Excel Preview"
									placement="bottom"
									v-if="/\.(csv|sheet)$/i.test(itemz.file_name)"
								>
									<img
										@click="show_excel(itemz.src)"
										src="../../../../assets/icons/excel.png"
										style="width: 400px; height: 480px; object-fit: cover"
									/>
								</el-tooltip>

								<el-tooltip
									class="item"
									effect="light"
									content="Click to show Excel Preview"
									placement="bottom"
									v-if="/\.(pdf)$/i.test(itemz.file_name)"
								>
									<PDFViewer
										ref="pdfViewer"
										:source="itemz.src"
										style="width: 100%; height: 500px"
										:key="'pdf_' + index"
										:rendering-text="renderingText"
										@rendered="onPDFRendered(index)"
										@download="handleDownload"
									/>
								</el-tooltip>
								<div>
									<el-row>
										<el-col :span="22">
											<span style="font-size: 11px">{{
												itemz.created_at
											}}</span>
										</el-col>
										<el-col :span="2">
											<div class="text-right">
												<i
													style="cursor: pointer"
													@click="delete_image(itemz, question)"
													class="el-icon-delete"
												/>
											</div>
										</el-col>
									</el-row>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</el-card>
			<ViewQuestionImagesVue
				:imagesArray="imagesArray"
				:viewQuestionImagesDialog="viewQuestionImagesDialog"
				@clicked="getAppropriateResponse"
				@close="viewQuestionImagesDialog = false"
				:currentItemIndex="currentItemIndex"
				@update:currentItemIndex="updateCurrentItemIndex"
			/>
		</div>
	</div>
</template>

<script>
import { EventBus } from "../../../../eventBus";
import SignaturePad from "signature_pad";
import formBuilderServices from "../../../../services/formBuilderServices";
var moment = require("moment");
import ViewQuestionImagesVue from "../ViewQuestionImagesQ.vue";
import PreviewLicenses from "../../LicenseManagement/PreviewLicenses.vue";

import Vue from "vue";
export default {
	props: {
		question: Object,
		sr_no: Number,
		Question_form_Details: Object,
		getImages: Object,
		initializeSignaturePad: Object,
		project_info_object: Object,
		allQuestions: Array,
		update_all: Boolean,
		current_question_idx: Number,
		currentCountryCode: String,
		countryList: Array,
		sendCountryCode: Boolean,
		show_buttons: Boolean,
		company_details: Object,
	},
	components: { SignaturePad, ViewQuestionImagesVue, PreviewLicenses },
	data: () => ({
		signaturePads: [],
		moment: moment,
		viewQuestionImagesDialog: false,
		imagesArray: [],
		current_question_points: 0,
		fileURLArray: [],
		fileURLArray1: [],
		fileURLArray2: [],
		fileURLArray3: [],
		currentItemIndex: 0,
		previewLicenseDialog: false,
		clicked_val: "",
		imgObject: {},
	}),
	async mounted() {
		if (
			this.question.form_question_info.input_type_info.name === "Mobile number"
		) {
			if (this.question.text_input && this.question.text_input.includes("-")) {
				const [countryCode, number] = this.question.text_input.split("-");
				this.question.country_number_input = countryCode;
				this.question.text_input = number;
			}
		}
		this.question.filesArray = [];
		this.question.fileURLArray = [];
		this.question.filesPreviewArray = [];
		this.question.signaturePads = [];
		if (this.question.form_question_info.input_type_info.name === "Signature") {
			setTimeout(() => {
				if (this.question.form_question_execution_attachments.length != 0) {
					this.getAttachmentsImages(this.question, this.sr_no, "Signature");
				} else {
					setTimeout(() => {
						this.initSignaturePads(this.question, this.sr_no);
					}, 100);
				}
			}, 1000);
		} else {
			if (this.question.form_question_execution_attachments.length != 0) {
				this.getAttachmentsImages1(this.question, this.sr_no, "Other");
			}
		}
		if (this.question.form_question_info.input_type_info.name == "Yes / No") {
			this.yes_no_count += 1;
			this.$forceUpdate();
			if (this.question.marked_as_na == false) {
				this.question.total_points =
					this.question.form_question_info.total_points;
				this.total_points += this.question.total_points;
			} else {
				this.question.total_points = 0;
			}

			if (this.question.boolean_input != null) {
				this.question.button_yes =
					this.question.boolean_input == true ? true : false;
				this.question.button_no =
					this.question.boolean_input == false ? true : false;
				if (this.question.button_yes) {
					this.question.green_color =
						"color:white; background:#41BE62; border-color:#41BE62";
					this.question.red_color = "";
					if (
						this.question.form_question_info.expected_responses_list.length != 0
					) {
						for (
							let j = 0;
							j <
							this.question.form_question_info.expected_responses_list.length;
							j++
						) {
							if (
								this.question.form_question_info.expected_responses_list[j]
									.expected_boolean_value == this.question.button_yes
							) {
								this.question.current_question_points =
									this.question[i].form_question_info.expected_responses_list[
										j
									].points_on_trigger;
							}
						}
					}
				}
				if (this.question.button_no) {
					this.question.red_color =
						"color:white; background:#FF0000; border-color:#FF0000";
					this.question.green_color = "";
					if (
						this.question.form_question_info.expected_responses_list.length != 0
					) {
						for (
							let j = 0;
							j <
							this.question.form_question_info.expected_responses_list.length;
							j++
						) {
							if (
								this.question.form_question_info.expected_responses_list[j]
									.expected_boolean_value == !this.question.button_no
							) {
								this.question.current_question_points =
									this.question.form_question_info.expected_responses_list[
										j
									].points_on_trigger;
							}
						}
					}
				}
			}
			this.current_question_points +=
				this.question.current_question_points != undefined
					? this.question.current_question_points
					: 0;
		}
		if (
			this.question.form_question_info.input_type_info.name == "Multiselect"
		) {
			if (this.question.multiple_input_options.length != 0) {
				for (
					let j = 0;
					j < this.question.form_question_info.input_options_list.length;
					j++
				) {
					for (
						let k = 0;
						k < this.question.multiple_input_options.length;
						k++
					) {
						if (
							this.question.form_question_info.input_options_list[j].id ==
							this.question.multiple_input_options[k]
						) {
							this.question.form_question_info.input_options_list[j].selected =
								this.question.multiple_input_options[k];
						}
					}
				}
			}
		}
		if (
			this.question.form_question_info.input_type_info.name == "Temperature"
		) {
			this.get_temperature_content(this.question, this.question.number_input);
			this.get_temperature_content_retest(
				this.question,
				this.question.repeat_number_input
			);
		}
		if (this.question.form_question_info.input_type_info.name == "TPM") {
			this.get_tpm_content(this.question, this.question.number_input);
			this.get_tpm_content_retest(
				this.question,
				this.question.repeat_number_input
			);
		}
		if (this.question.form_question_info.input_type_info.name == "Rating") {
			this.question.form_question_info.rating =
				this.question.number_input == null ? null : this.question.number_input;
			this.question.rating_list = [];
			for (
				let r = this.question.form_question_info.minimum_value;
				r <= this.question.form_question_info.maximum_value;
				r++
			) {
				this.question.rating_list.push({
					label: r,
					value: r,
				});
			}
		}
		if (this.question.form_question_info.input_type_info.name == "Checklist") {
			if (this.question.boolean_input) {
				this.question.checked = true;
			}
		}
		let green = 0;
		let red = 0;
		if (this.question.button_yes != true) {
			red += 1;
		}
		if (this.question.button_no != true) {
			green += 1;
		}
		if (green != 0 && red != 0) {
			this.green_color = "";
			this.red_color = "";
		} else {
			if (green > 0) {
				this.green_color =
					"color:white; background:#41BE62; border-color:#41BE62";
				if (this.Question_form_Details.scoring_type == "all_pass") {
					this.all_pass_current_question_points =
						this.Question_form_Details.total_points;
				}
			}
			if (red > 0) {
				this.red_color =
					"color:white; background:#FF0000; border-color:#FF0000";
			}
		}
		this.$forceUpdate();
	},
	watch: {
		update_all(val) {
			if (val) {
				this.$forceUpdate();
			}
		},
		sendCountryCode(val) {
			if (val) {
				if (
					this.question.form_question_info.input_type_info.name ==
					"Mobile number"
				) {
					if (this.question.text_input == null) {
						this.question.country_number_input = this.currentCountryCode;
						this.$forceUpdate();
					}
				}
			}
		},
	},
	methods: {
		checkDisabled(question) {
			if (
				(question.marked_as_na ||
					(this.company_details.access_level != "admin" &&
						this.company_details.access_level != "super")) &&
				!this.show_buttons
			) {
				return true;
			} else {
				return false;
			}
		},
		updateCurrentItemIndex(newIndex) {
			this.currentItemIndex = null;
			this.currentItemIndex = newIndex;
			this.$forceUpdate();
		},
		validateInput(question) {
			const value = question.text_input.toString();
			const numericValue = value.replace(/\D/g, "");
			question.text_input = numericValue.slice(0, 10);
			return Number(question.text_input);
		},
		show_excel(excel) {
			window.open(excel);
		},
		splitText(text) {
			const chunkSize = 75;
			const chunks = [];
			let start = 0;
			while (start < text.length) {
				let end = start + chunkSize;
				if (end < text.length) {
					while (end > start && text[end] !== " ") {
						end--;
					}
				}
				if (end === start) {
					end = start + chunkSize;
				}
				chunks.push(text.slice(start, end).trim());
				start = end;
			}
			return chunks;
		},
		splitOptionText(text) {
			const chunks = this.splitText(text);
			return chunks.join("\n"); // Join chunks with a line break or any delimiter you prefer
		},
		get_marked_as_na_values(item, val) {
			this.total_points = 0;
			this.current_question_points = 0;
			if (val == true) {
				item.total_points = 0;
				item.current_question_points = 0;
				for (let i = 0; i < this.allQuestions.length; i++) {
					this.total_points += this.allQuestions[i].total_points;
					this.current_question_points +=
						this.allQuestions[i].current_question_points != undefined
							? this.allQuestions[i].current_question_points
							: 0;
				}
			} else {
				item.total_points = item.form_question_info.total_points;
				item.red_color = "";
				item.green_color = "";
				item.boolean_input = null;
				item.button_no = null;
				item.button_yes = null;
				for (let i = 0; i < this.allQuestions.length; i++) {
					this.total_points += this.allQuestions[i].total_points;
					this.allQuestions[i].current_question_points = 0;
					this.current_question_points +=
						this.allQuestions[i].current_question_points != undefined
							? this.allQuestions[i].current_question_points
							: 0;
				}
				this.green_color = "";
				this.red_color = "";
			}
		},
		getAppropriateResponse() {
			this.$emit(
				"get_updated_array",
				this.formDetails,
				this.current_question_idx
			);
			this.viewQuestionImagesDialog = false;
		},
		async get_image(arr) {
			try {
				const promises = arr.map(async (el) => {
					el.fileDetails = { name: "" };
					let params = {
						file_path: el.file_path,
						storage: "task",
					};
					const res = await formBuilderServices.getAttachmentURL(params);
					el.src = JSON.parse(res.data).data;
					el.fileDetails = { name: el.file_name };
				});

				await Promise.all(promises);

				this.imagesArray = arr;
				setTimeout(() => {
					this.viewQuestionImagesDialog = true;
					this.$forceUpdate();
				}, 100);
			} catch (error) {
				console.error("Error fetching images:", error);
			}
		},
		get_temperature_content(item, number) {
			if (item.number_input != "" && item.number_input != null) {
				if (
					number >= item.form_question_info.minimum_value &&
					number <= item.form_question_info.maximum_value
				) {
					item.show_temp_retest = false;
					item.test_color = "";
				} else {
					item.test_color = "#FF0000";
					item.test_color_retest = "";
					item.show_temp_retest = true;
				}
			} else {
				item.show_temp_retest = false;
				item.test_color = "";
			}
			return item;
		},
		get_temperature_content_retest(item, number) {
			if (item.number_input != "") {
				if (
					number >= item.form_question_info.minimum_value &&
					number <= item.form_question_info.maximum_value
				) {
					item.test_color_retest = "";
				} else {
					item.test_color_retest = "#FF0000";
				}
			}
			return item;
		},
		get_tpm_content(item, number) {
			if (item.number_input != "" && item.number_input != null) {
				if (
					number >= item.form_question_info.minimum_value &&
					number <= item.form_question_info.maximum_value
				) {
					item.show_tpm_retest = false;
					item.test_color_tpm = "";
				} else {
					item.test_color_tpm = "#FF0000";
					item.show_tpm_retest = true;
					item.test_color_tpm_retest = "";
				}
			} else {
				item.show_tpm_retest = false;
				item.test_color_tpm = "";
			}
			return item;
		},
		get_tpm_content_retest(item, number) {
			if (item.number_input != "") {
				if (
					number >= item.form_question_info.minimum_value &&
					number <= item.form_question_info.maximum_value
				) {
					item.test_color_tpm_retest = "";
				} else {
					item.test_color_tpm_retest = "#FF0000";
				}
			}
			return item;
		},
		button_condition_no(item, idx) {
			this.current_question_points = 0;
			this.red_color = "";
			item.button_yes = false;
			item.button_no = true;
			item.red_color = item.button_no
				? "color:white; background:#FF0000; border-color:#FF0000"
				: "color:'#d26300'";
			item.green_color = "";
			if (this.Question_form_Details.scoring_type != "all_pass") {
				for (
					let j = 0;
					j < this.question.form_question_info.expected_responses_list.length;
					j++
				) {
					if (
						this.question.form_question_info.expected_responses_list[j]
							.expected_boolean_value == !item.button_no
					) {
						this.question.current_question_points =
							this.question.form_question_info.expected_responses_list[
								j
							].points_on_trigger;
						this.current_question_points +=
							this.question.current_question_points;
					}
				}
				let current_question_points = 0;
				for (let i = 0; i < this.question.length; i++) {
					if (
						this.question.form_question_info.input_type_info.name == "Yes / No"
					) {
						current_question_points += Number(
							this.question.current_question_points != undefined
								? this.question.current_question_points
								: 0
						);
					}
				}
				this.current_question_points = current_question_points;
				let green = 0;
				for (let i = 0; i < this.question.length; i++) {
					if (
						this.question.form_question_info.input_type_info.name == "Yes / No"
					) {
						if (this.question.button_no != true) {
							green += 1;
						}
					}
				}
				if (green == 0) {
					this.red_color =
						"color:white; background:#FF0000; border-color:#FF0000";
				} else {
				}
				this.green_color = "";
			} else {
				this.green_color = "";
				this.all_pass_current_question_points = 0;
			}
			this.$forceUpdate();

			return item;
		},
		button_condition_yes(item, idx) {
			this.green_color = "";
			this.red_color = "";
			this.current_question_points = 0;
			item.button_yes = true;
			item.button_no = false;
			item.green_color = item.button_yes
				? "color:white; background:#41BE62; border-color:#41BE62"
				: "color:'#d26300'";
			item.red_color = "";
			if (this.Question_form_Details.scoring_type != "all_pass") {
				for (
					let j = 0;
					j < this.question.form_question_info.expected_responses_list.length;
					j++
				) {
					if (
						this.question.form_question_info.expected_responses_list[j]
							.expected_boolean_value == item.button_yes
					) {
						this.question.current_question_points =
							this.question.form_question_info.expected_responses_list[
								j
							].points_on_trigger;
					}
				}
				let current_question_points = 0;
				for (let i = 0; i < this.question.length; i++) {
					if (
						this.question.form_question_info.input_type_info.name == "Yes / No"
					) {
						current_question_points += Number(
							this.question.current_question_points != undefined
								? this.question.current_question_points
								: 0
						);
					}
				}
				this.current_question_points = current_question_points;
				let red = 0;
				for (let i = 0; i < this.question.length; i++) {
					if (
						this.question.form_question_info.input_type_info.name == "Yes / No"
					) {
						if (this.question.button_yes != true) {
							red += 1;
						}
					}
				}
				if (red == 0) {
					this.green_color =
						"color:white; background:#41BE62; border-color:#41BE62";
				} else {
					this.green_color = "";
				}
			} else {
				let red = 0;
				for (let i = 0; i < this.question.length; i++) {
					if (
						this.question.form_question_info.input_type_info.name == "Yes / No"
					) {
						if (this.question.button_yes != true) {
							red += 1;
						}
					}
				}
				if (red == 0) {
					this.green_color =
						"color:white; background:#41BE62; border-color:#41BE62";
					this.all_pass_current_question_points =
						this.Question_form_Details.total_points;
				} else {
					this.green_color = "";
				}
				this.red_color = "";
			}
			this.red_color = "";
			this.$forceUpdate();
			return item;
		},
		shouldDisableStart(index, attemptIndex, item) {
			if (attemptIndex === 0 && !item.isRunning[attemptIndex]) {
				return false;
			}
			if (
				attemptIndex > 0 &&
				item.stopwatches[attemptIndex - 1].stopped &&
				!item.isRunning[attemptIndex]
			) {
				return false;
			}
			if (attemptIndex === item.nextIndex && !item.isRunning[attemptIndex]) {
				return false;
			}
			if (item.stopwatches[attemptIndex - 1].id) {
				if (attemptIndex + 1 < item.stopwatches.length) {
					if (!item.isRunning[attemptIndex + 1]) {
						return false;
					}
				}
			}
			return true;
		},
		stopStopwatch(index, attemptIndex, item) {
			this.$set(item.showStartButton, attemptIndex, false);
			this.$set(item.showStopButton, attemptIndex, false);
			this.$set(item.showResetButton, attemptIndex, true);
			item.isRunning[attemptIndex] = false;
			clearInterval(item.interval[attemptIndex]);
			item.nextIndex = attemptIndex + 1;
			while (
				item.nextIndex < item.stopwatches.length &&
				item.stopwatches[item.nextIndex].stopped
			) {
				item.nextIndex++;
			}

			for (let i = 0; i < item.stopwatches.length; i++) {
				item.stopwatches[i].new_time = this.formatTime(
					item.stopwatches[i].time
				);
			}
			this.$forceUpdate();
		},
		startStopwatch(index, attemptIndex, item) {
			this.$set(item.showStartButton, attemptIndex, false);
			this.$set(item.showStopButton, attemptIndex, true);
			if (item.stopwatches[attemptIndex].id) {
				// Retain the existing id, time, and serial_no properties
				const { id, time, serial_no } = item.stopwatches[attemptIndex];
				this.$set(item.stopwatches, attemptIndex, { id, time, serial_no });
			} else {
				this.$set(item.stopwatches, attemptIndex, { time: 0 });
			}
			this.$set(item.isRunning, attemptIndex, true);
			item.interval[attemptIndex] = setInterval(() => {
				this.$set(
					item.stopwatches[attemptIndex],
					"time",
					item.stopwatches[attemptIndex].time + 1000
				);
				// Call formatTime for every interval update
				this.formatTime(item.stopwatches[attemptIndex].time, item);
				this.$forceUpdate();
			}, 1000);
		},
		resetStopwatch(index, attemptIndex, item) {
			if (item.stopwatches[attemptIndex].id) {
				let params = {
					timer_ids: [item.stopwatches[attemptIndex].id],
				};
				formBuilderServices.deleteTimer(params).then((res) => {
					console.log(res, "tsg");
				});
			}
			clearInterval(item.interval[attemptIndex]);
			item.isRunning[attemptIndex] = false;
			item.stopwatches[attemptIndex].time = 0;
			this.$set(item.showStartButton, attemptIndex, true);
			this.$set(item.showStopButton, attemptIndex, false);
			this.$set(item.showResetButton, attemptIndex, false);
			item.stopwatches[attemptIndex].new_time = this.formatTime(
				item.stopwatches[attemptIndex].time
			);
			for (let i = attemptIndex + 1; i < item.stopwatches.length; i++) {
				if (!item.stopwatches[attemptIndex].id) {
					this.$set(item.showStartButton, i, true); // Show the start button
					this.$set(item.isRunning, i, false); // Ensure it's not running
					this.$set(item.stopwatches[i], "time", 0); // Reset the time
					this.$set(item.showStartButton, i, true); // Enable the button but disable it
				}
			}
			this.$forceUpdate();
		},
		formatTime(time, item) {
			if (isNaN(time) || time < 0) {
				return {
					formattedTime: "00:00:00",
					item: item,
				};
			}
			if (!time) {
				return {
					formattedTime: "00:00:00",
					item: item,
				};
			}
			if (time == 0) {
				return {
					formattedTime: "00:00:00",
					item: item,
				};
			}
			const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
			const minutes = Math.floor((time / (1000 * 60)) % 60);
			const seconds = Math.floor((time / 1000) % 60);
			const formattedTime = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(
				seconds
			)}`;
			return {
				formattedTime: formattedTime,
				item: item,
			};
		},
		pad(num) {
			return num.toString().padStart(2, "0");
		},
		totalTime(item) {
			let totalMilliseconds = 0;
			item.stopwatches.forEach((stopwatch) => {
				totalMilliseconds += stopwatch.time;
			});
			const totalSeconds = Math.floor(totalMilliseconds / 1000);
			const hours = Math.floor(totalSeconds / 3600);
			const minutes = Math.floor((totalSeconds % 3600) / 60);
			const seconds = totalSeconds % 60;
			return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
		},
		averageTime(item) {
			if (item.stopwatches.length === 0) {
				return "00:00:00";
			}
			const totalMilliseconds = item.stopwatches.reduce(
				(acc, stopwatch) => acc + stopwatch.time,
				0
			);
			const averageMilliseconds = totalMilliseconds / item.stopwatches.length;
			const totalSeconds = Math.floor(averageMilliseconds / 1000);
			const hours = Math.floor(totalSeconds / 3600);
			const minutes = Math.floor((totalSeconds % 3600) / 60);
			const seconds = totalSeconds % 60;
			return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
		},
		initSignaturePads(question, index) {
			setTimeout(() => {
				this.$nextTick(() => {
					const canvasArray = this.$refs[`question.signatureCanvas${index}`];
					const canvas = canvasArray ? canvasArray : null;
					if (canvas && canvas.getContext) {
						const signaturePad = new SignaturePad(canvas);
						question.signaturePads = signaturePad;
					} else {
						console.error(
							`Canvas element not found or not ready for item ${index}.`
						);
					}
				});
			}, 300);
		},
		clearSignature(index, item) {
			const canvas = this.$refs[`question.signatureCanvas${index}`];
			if (canvas) {
				const ctx = canvas.getContext("2d");
				ctx.clearRect(0, 0, canvas.width, canvas.height);
			}
			if (item.form_question_execution_attachments.length != 0) {
				if (item.form_question_execution_attachments[0].id) {
					formBuilderServices
						.deleteAttachments({
							id: item.form_question_execution_attachments[0].id,
						})
						.then((res) => {
							console.log(res, "resp");
						});
				}
				item.form_question_execution_attachments = [];
				this.initSignaturePads(item, index);
			}
		},
		async getAttachmentsImages(question, index, type) {
			question.filesArray = [];
			question.fileURLArray = [];
			question.filesPreviewArray = [];
			let attachments = question.form_question_execution_attachments;

			if (attachments.length > 0) {
				this.$set(question, "image_conatined", true);
				this.$set(question, "show_image", false);
			}

			if (attachments.length > 0) {
				try {
					const updatedAttachments = await Promise.all(
						attachments.map(async (attachment) => {
							let params = {
								file_path: attachment.file_path,
								storage: "task",
							};
							const res = await formBuilderServices.getAttachmentURL(params);
							let attachmentData = JSON.parse(res.data).data;
							this.$set(attachment, "src", attachmentData); // Use this.$set for reactivity
							return attachment;
						})
					);

					this.$set(
						question,
						"form_question_execution_attachments",
						updatedAttachments
					);
				} catch (error) {
					console.error("Error fetching attachment URLs:", error);
				}
			}

			this.$forceUpdate(); // Force re-render if necessary
			return question;
		},
		async getAttachmentsImages1(question, index, type) {
			question.filesArray = [];
			question.fileURLArray = [];
			question.filesPreviewArray = [];
			let attachments = question.form_question_execution_attachments;
			if (attachments.length > 0) {
				this.$set(question, "image_conatined", true);
				this.$set(question, "show_image", false);
			}
			if (attachments.length > 0) {
				try {
					const updatedAttachments = await Promise.all(
						attachments.map(async (attachment) => {
							let params = {
								file_path: attachment.file_path,
								storage: "task",
							};
							const res = await formBuilderServices.getAttachmentURL(params);
							let attachmentData = JSON.parse(res.data).data;
							if (type === "Other") {
								this.$set(
									attachment,
									"created_at",
									moment
										.utc(attachment.created_at)
										.local()
										.format("Do MMM YY, HH:mm:ss")
								);
							}
							this.$set(attachment, "src", attachmentData); // Use this.$set for reactivity
							return attachment;
						})
					);
					this.$set(
						question,
						"form_question_execution_attachments",
						updatedAttachments
					);

					if (type === "Other") {
						this.$set(question, "fileURLArray", updatedAttachments);
					}
				} catch (error) {
					console.error("Error fetching attachment URLs:", error);
				}
			}

			this.$forceUpdate(); // Force re-render if necessary
			return question;
		},
		raise_ticket(item) {
			if (item.actions.length == 0) {
				this.current_obj_obj = item;
				this.$emit("raise", item);
			} else {
				alert("Action already raised");
			}
		},
		clear_selection(item, idx) {
			console.log(item, "item");
			switch (item.form_question_info.input_type_info.name) {
				case "Yes / No":
					this.clearYesNoFields(item);
					break;
				case "Checklist":
					Vue.set(item, "checked", null);
					break;
				case "Timer":
					item.form_question_info.stopwatches = Array.from(
						{ length: item.form_question_info.timer_attempts },
						() => ({
							time: 0, // or whatever default value you want
							isRunning: false, // assuming you have a flag to track stopwatch status
						})
					);
					item.form_question_info.showStartButton = Array.from(
						{ length: item.form_question_info.timer_attempts },
						() => true
					);
					item.form_question_info.showStopButton = Array.from(
						{ length: item.form_question_info.timer_attempts },
						() => false
					);
					item.form_question_info.showResetButton = Array.from(
						{ length: item.form_question_info.timer_attempts },
						() => false
					);
					break;
				case "Date":
					Vue.set(item, "date_input", null);
					break;
				case "Time":
					Vue.set(item, "time_input", null);
					break;
				case "Datetime":
					Vue.set(item, "datetime_input", null);
					break;

				case "Select any one":
					this.clearSelectAnyOneFields(item);
					break;
				case "Dropdown":
					Vue.set(item.form_question_info, "checked", null);
					break;
				case "Multiselect":
					this.clearMultiselectFields(item);
					break;
				case "Long Text":
				case "Long text":
				case "Short text":
				case "Number input":
				case "Mobile number":
				case "Email":
					Vue.set(item, "text_input", null);
					Vue.set(item, "number_input", null);
					break;
				case "Temperature":
				case "TPM":
					this.clearTemperatureTPMFields(item);
					break;
				case "Signature":
					this.clearSignature(idx, item);
					break;
				case "Rating":
					Vue.set(item, "number_input", 0);
					setTimeout(() => {
						Vue.set(item, "number_input", null);
					}, 300);
					break;
				default:
					console.warn(
						`Unhandled input type: ${item.form_question_info.input_type_info.name}`
					);
			}
			item.current_question_points = 0;
			let current_question_points = 0;
			for (let i = 0; i < this.allQuestions.length; i++) {
				current_question_points +=
					this.allQuestions[i].current_question_points != undefined
						? Number(this.allQuestions[i].current_question_points)
						: 0;
			}
			this.current_question_points = current_question_points;

			this.$forceUpdate(); // Consider removing if reactivity is ensured
		},
		update_rating() {
			this.$forceUpdate();
			return this.question;
		},
		clearYesNoFields(item) {
			Vue.set(this, "green_color", "");
			Vue.set(this, "red_color", "");
			Vue.set(item, "boolean_input", null);
			Vue.set(item, "button_no", null);
			Vue.set(item, "button_yes", null);
			Vue.set(item, "red_color", "");
			Vue.set(item, "green_color", "");
			Vue.set(item, "current_question_points", 0);
		},
		clearSelectAnyOneFields(item) {
			Vue.set(item, "input_option", null);
			item.form_question_info.input_options_list.forEach((option) => {
				Vue.set(option, "checked", false);
			});
		},
		clearMultiselectFields(item) {
			// Vue.set(item, "multiple_input_options", []);
			// item.form_question_info.input_options_list.forEach((option) => {
			Vue.set(item, "input_option", false);
			// });
		},
		clearTemperatureTPMFields(item) {
			Vue.set(item, "number_input", null);
			Vue.set(item, "repeat_number_input", null);
			Vue.set(item, "test_color", null);
			Vue.set(item, "test_color_retest", null);
			Vue.set(item, "show_temp_retest", false);
			Vue.set(item, "test_color_tpm", null);
			Vue.set(item, "test_color_tpm_retest", null);
			Vue.set(item, "show_tpm_retest", false);
		},
		updateCurrentQuestionPoints() {
			let current_question_points = this.allQuestions.reduce((total, item) => {
				return (
					total +
					(item.current_question_points != undefined
						? Number(item.current_question_points)
						: 0)
				);
			}, 0);
			Vue.set(this, "current_question_points", current_question_points);
		},
		image_upload(id) {
			document.getElementById("fileUploadSelector" + id).click();
		},
		async upload_file_handler(event, item) {
			const filesArray = event.target.files;
			let imageCount = this.question.fileURLArray.length; // Get current image count
			if (imageCount + filesArray.length > 4) {
				alert("You can upload a maximum of 4 images.");
				return; // Exit function
			}
			for (let i = 0; i < filesArray.length; i++) {
				const file = filesArray[i];
				if (file.type.startsWith("image/")) {
					const isDuplicate = this.question.fileURLArray.some(
						(image) => image === URL.createObjectURL(file)
					);
					if (isDuplicate) {
						alert("This image is already uploaded.");
						continue; // Skip this file
					}
					if (file.size > 500 * 1024) {
						const compressedImage = await this.compressImage(file);
						this.question.filesArray.push(compressedImage);
						const compressedSizeKB = Math.round(compressedImage.size / 1024); // Convert bytes to KB
					} else {
						this.question.filesArray.push(file);
					}
					const obj = {
						fileDetails: file,
						src: URL.createObjectURL(file), // Generate Blob URL for image preview
						file_name: file.name,
					};
					this.question.filesPreviewArray.push(obj);
					this.question.fileURLArray.push(obj);
				} else {
					alert("Please upload only image files.");
				}
			}
			if (this.question.fileURLArray.length > imageCount) {
				this.uploadFiles();
			}
		},
		async compressImage(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = (event) => {
					const img = new Image();
					img.onload = () => {
						const canvas = document.createElement("canvas");
						const ctx = canvas.getContext("2d");
						let newWidth = img.width;
						let newHeight = img.height;
						const maxSize = 500 * 1024; // 500 KB in bytes
						while (newWidth * newHeight * 4 > maxSize) {
							newWidth *= 0.9;
							newHeight *= 0.9;
						}
						canvas.width = newWidth;
						canvas.height = newHeight;
						ctx.drawImage(img, 0, 0, newWidth, newHeight);
						canvas.toBlob(
							(blob) => {
								const compressedFile = new File([blob], file.name, {
									type: "image/jpeg",
									lastModified: Date.now(),
								});
								resolve(compressedFile);
							},
							"image/jpeg",
							0.7
						); // JPEG compression quality 0.7
					};
					img.src = event.target.result;
				};
				reader.readAsDataURL(file);
			});
		},
		uploadFiles() {
			const formData = new FormData();
			const filesArray = this.question.filesArray;
			for (let i = 0; i < filesArray.length; i++) {
				formData.append("attachments", filesArray[i]);
				formData.append("storage", "task");
			}
			formBuilderServices
				.uploadImageAttachment(formData)
				.then((res) => {
					this.question.form_question_execution_attachments = JSON.parse(
						res.data
					).data;
					this.$forceUpdate();
				})
				.catch((error) => {
					console.error("Error uploading files:", error);
				});
		},
		delete_image(item, m_item) {
			if (item.id) {
				formBuilderServices.deleteAttachments({ id: item.id }).then((res) => {
					console.log(res, "resp");
				});
			}
			const indexToRemove = m_item.fileURLArray.findIndex(
				(file) => file.file_name === item.file_name
			);
			if (indexToRemove !== -1) {
				// Use Vue.set or splice to update the array in a reactive way
				this.$set(m_item.fileURLArray, indexToRemove, undefined);
				m_item.fileURLArray.splice(indexToRemove, 1);
			}
			this.$notify.success({
				title: "Success",
				message: "Attachment Deleted Successfully",
				type: "success",
			});
			this.$forceUpdate();
			return m_item;
		},
		show_comment(item) {
			item.show_comment = true;
			this.$forceUpdate();
			return item;
		},
		hide_comment(item) {
			item.show_comment = false;
			this.$forceUpdate();
			return item;
		},
	},
};
</script>

<style>
.comment-container {
	display: flex;
	justify-content: flex-end;
}

.hide-comment-btn {
	height: 40px;
	text-align: center;
	border-radius: 12px;
	border: 1px solid #d26300;
	color: #d26300;
	cursor: pointer;
	display: flex;
	justify-content: center;
	width: 20%;
	margin-top: 10px;
}

.hide-comment-text {
	padding-top: 10px;
}
.el-select-dropdown__item {
	width: 100% !important;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.el-select-dropdown {
	max-width: 30% !important;
}
</style>
